import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=ccd17454&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd17454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccd17454')) {
      api.createRecord('ccd17454', component.options)
    } else {
      api.reload('ccd17454', component.options)
    }
    module.hot.accept("./SubCategories.vue?vue&type=template&id=ccd17454&scoped=true", function () {
      api.rerender('ccd17454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/SubCategories.vue"
export default component.exports